export const SA_PRODUCT_CODE = 'SA';
export const BUYER_SUBSCRIPTION_TYPE = 'BUYER';
export const SELLER_SUBSCRIPTION_TYPE = 'SELLER';
